module.exports = __webpack_public_path__ + "static/media/trueRelief-image.be2e44af.png";